import React from 'react';

const Burger = ({ isOpen }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 22">
      <path
        d={`M0 ${!isOpen ? '0h44v2H0zm0' : ''} 10h44v2H0zm0 ${
          !isOpen ? '10h44v2H0z' : ''
        }`}
      ></path>
    </svg>
  );
};

export default Burger;
